<template>
	<div>
		<template v-if="focusedClient">
			<ChildStonks/>
		</template>
		<template v-else>
			<div
				ref="entryPanel"
				class="scrollable is-flex is-flex-direction-column"
			>
				<EmptyState
					message="Kein Klient ausgewählt."
				/>
			</div>
		</template>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import ChildStonks from "@/components/charts/ChildStonks";
import EmptyState from "@/components/helper/EmptyState";

export default {
	name: "Charts",
	components: {ChildStonks, EmptyState},
	computed: {
		...mapGetters({
			focusedClient: "clients/getFocusedClient"
		})
	}

}
</script>

<style scoped>

</style>
